import request from '@/libs/functions/request'
import { ModuleInfoMap } from '@/utils/lang/types'

// 等级数据
export function getLangPacksVersionAndUrls(params: {
  channel: string
  moduleCodes: string[]
  tenantCode: string
}) {
  return request<{
    lang: ModuleInfoMap
    defaultLang: string
    supportLangs?: string[]
  }>({
    uri: '/api/business/member/language/languagePackage/get',
    params,
    method: 'POST',
  })
}
